export const PROFILE_CONFIG_TAG_TYPE = 'ProfileConfig' as const;
export const PROFILE_WIDGETS_TAG_TYPE = 'ProfileWidgets' as const;

export const ALL_CONFIGS_ID = 'ALL_CONFIGS' as const;
export const FEEDBACK_TAG_TYPE = 'Feedback' as const;
